module.exports = __webpack_public_path__ + "static/media/ic-bed-grey.520687e8.svg";